module.exports = __webpack_public_path__ + "img/logo-icon.b672c448.png";